import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import SelectedElementCollection from "./partial/selected-element-collection";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import withStyles from "components/with-styles";
import Label from "../partial/label";
import FormHelperText from "components/form/form-helper-text";
import MenuItem from "@material-ui/core/MenuItem";
import styles, { menuStyle } from "./styles/select-multiple-chip.css.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import FormFieldError from "components/form/form-field-error";

const renderInputSelect = (id, name) => <Input id={id} name={name} />;

const SelectMultipleChip = ({
  className,
  classes,
  getValueFromElement,
  getLabelFromElement,
  label,
  id,
  name,
  value = [],
  onChange,
  elements = [],
  helperText,
  disabled = false,
  marginDense = false,
  selectClasses = {},
  ...props
}) => {
  const matchesMobile = useMediaQuery("(max-width: 385px)");

  return (
    <FormControl
      disabled={disabled}
      margin="normal"
      fullWidth
      className={cn(classes.container, classes.formControl, className)}
    >
      <Label id={id} label={label} />

      <Select
        classes={
          marginDense && matchesMobile ? { select: classes.select_dense, ...selectClasses } : { ...selectClasses }
        }
        multiple
        MenuProps={menuStyle}
        name={name}
        input={renderInputSelect(id, name)}
        renderValue={selected => (
          <SelectedElementCollection
            key={value}
            selected={selected}
            elements={elements}
            value={value}
            getValueFromElement={getValueFromElement}
            getLabelFromElement={getLabelFromElement}
          />
        )}
        value={value ? value : []}
        onChange={onChange}
        {...props}
      >
        {elements.map(element => (
          <MenuItem
            classes={{
              root: classes.menuItem,
            }}
            key={getValueFromElement(element)}
            value={getValueFromElement(element)}
          >
            {getLabelFromElement(element)}
          </MenuItem>
        ))}
      </Select>

      <FormHelperText text={helperText} />
      <FormFieldError name={name} />
    </FormControl>
  );
};

SelectMultipleChip.propTypes = {
  /**
   * Material UI select classes object
   */
  selectClasses: PropTypes.object,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Etiqueta opcional para el campo
   */
  label: PropTypes.string,
  /**
   * Id del selector
   */
  id: PropTypes.string.isRequired,
  /**
   * Nombre del selector
   */
  name: PropTypes.string.isRequired,
  /**
   * Valor actual del selector
   */
  value: PropTypes.array,
  /**
   * Función que se ejecuta al cambiar el valor del campo
   */
  onChange: PropTypes.func,
  /**
   * Función que obtiene el valor de la opción a partir de un elemento
   */
  getValueFromElement: PropTypes.func.isRequired,
  /**
   * Función que obtiene el valor de la etiqueta a partir de un elemento
   */
  getLabelFromElement: PropTypes.func.isRequired,
  /**
   * Colección de elementos del selector
   */
  elements: PropTypes.array.isRequired,
  /**
   * Texto de ayuda que aparece bajo el select
   */
  helperText: PropTypes.string,
  /**
   * Indica si el campo está deshabilitado
   */
  disabled: PropTypes.bool,
  /**
   * Indica si se aplican los estilos para placeholders multilínea en dispositivos móviles
   */
  marginDense: PropTypes.bool,
};

export default withStyles(styles)(SelectMultipleChip);
